import { Reveal } from "./Reveal";
import { SCHEDULE } from "../../data";

const todayIdx = () => {
  // Only Mon–Thu currently offered. Mon=0..Thu=3, else -1.
  const d = new Date().getDay(); // 0=Sun..6=Sat
  const map = { 1: 0, 2: 1, 3: 2, 4: 3 };
  return d in map ? map[d] : -1;
};

export default function Schedule() {
  const active = todayIdx();
  return (
    <section
      id="schedule"
      className="relative bg-[#0C0C0C] py-24 md:py-36 px-6 lg:px-10"
      data-testid="schedule-section"
    >
      <div className="mx-auto max-w-[1400px]">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <Reveal>
              <p className="font-body text-xs md:text-sm uppercase tracking-[0.3em] text-teal mb-6">
                / Weekly Schedule
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display font-700 uppercase leading-[0.9] tracking-tighter text-white text-5xl md:text-6xl lg:text-7xl">
                Show up. Every day.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-xs font-body text-sm text-neutral-400 leading-relaxed">
              Times shown are local. First class is always free — no commitment,
              just come train.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-lg overflow-hidden">
          {SCHEDULE.map((s, i) => (
            <Reveal
              key={s.day}
              delay={i * 0.05}
              className={`min-h-[240px] p-6 ${
                i === active ? "bg-[#161016]" : "bg-[#121212]"
              }`}
              data-testid={`schedule-day-${s.day}`}
            >
              <div className="flex items-center justify-between mb-5">
                <span
                  className={`font-display uppercase tracking-tight text-2xl ${
                    i === active ? "text-hotpink" : "text-white"
                  }`}
                >
                  {s.day}
                </span>
                {i === active && (
                  <span className="font-body text-[9px] uppercase tracking-[0.2em] text-teal border border-teal/40 rounded-full px-2 py-0.5">
                    Today
                  </span>
                )}
              </div>
              <ul className="space-y-4">
                {s.sessions.map((sess) => (
                  <li
                    key={`${s.day}-${sess.time}-${sess.name}`}
                    className={`border-l-2 pl-3 ${
                      sess.invitationOnly
                        ? "border-hotpink/70"
                        : "border-white/10 hover:border-teal transition-colors duration-300"
                    }`}
                  >
                    <div className="font-body text-[11px] uppercase tracking-[0.2em] text-neutral-500">
                      {sess.time}
                    </div>
                    <div className="font-display uppercase tracking-tight text-base text-white leading-snug">
                      {sess.name}
                    </div>
                    {sess.invitationOnly && (
                      <div className="mt-2 inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border border-hotpink/50 bg-hotpink/10">
                        <span className="h-1.5 w-1.5 rounded-full bg-hotpink" />
                        <span className="font-body text-[9px] uppercase tracking-[0.22em] text-hotpink">
                          Invitation Only
                        </span>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
